export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('state')
    if (serializedState === null) {
      return undefined
    }
    return JSON.parse(serializedState)
  } catch (err) {
    return undefined
  }
}

export const saveState = ({ gallery }) => {
  try {
    const serializedState = JSON.stringify({
      gallery: {
        ...gallery,
        scrollPosition: 0,
      },
    })
    localStorage.setItem('state', serializedState)
  } catch (err) {
    // Ignore write errors.
  }
}



// WEBPACK FOOTER //
// ./src/state/localStorage.js